// @flow

import { combineReducers } from 'redux';

import { reducer as themeReducer } from './theme/';

export default combineReducers({
  theme: themeReducer
});



// WEBPACK FOOTER //
// ./src/store/reducers/ui/reducer.js